import { render, staticRenderFns } from "./SmartCaptcha.vue?vue&type=template&id=cfe396a2&"
import script from "./SmartCaptcha.vue?vue&type=script&lang=js&"
export * from "./SmartCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports